<template>
    <div>
        <ul class="flex flex-col md:flex-row cursor-pointer text-center">
            <li
                v-for="(tab, i) in tabs"
                :key="i"
                :class="[tabClass, tab.isActive ?  activeTabClass : '']"
                @click="selectTab(tab)">
                {{ tab.title }}
            </li>
        </ul>
        <div :class="contentClass">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabClass: {},
        activeTabClass: {},
        contentClass: {},
        enableRouting: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        tabs: []
    }),
    created() {
        this.tabs = this.$children;
    },
    mounted() {
        if (this.tabs.length) {
            if (this.$route.query.tab && this.enableRouting) {
                const tabToSelect = this.tabs.find(t => t.title === this.$route.query.tab);
                this.selectTab(tabToSelect);
            } else {
                this.selectTab(this.tabs[0]);
            }
        }
    },
    methods: {
        selectTab(tab) {
            const selectedTab = this.tabs.find(t => t.computedId === tab.computedId);
            if (!selectedTab) {
                return;
            }
            this.select(selectedTab);
        },
        selectTabByTitle(tabTitle) {
            const selectedTab = this.tabs.find(t => t.title === tabTitle);
            if (!selectedTab) {
                return;
            }
            this.select(selectedTab);
        },
        select(selectedTab) {
            if (this.enableRouting) {
                let newQuery = Object.assign({}, this.$route.query);
                newQuery.tab = selectedTab.title;
                this.$router.replace({ query: newQuery })
                    .catch(() => {
                    });
            }
            this.tabs.forEach(tab => tab.isActive = tab.computedId === selectedTab.computedId);
        }
    }
};
</script>
